import { IReflektionFacet } from '@/js/services/rfk/types'
import type { LocationQuery } from 'vue-router'

// Only allow one at a time
const SINGLE_FACET = ['deal_type', 'cat1', 'cat2', 'cat3', 'category']

// Non-facet params that are valid to carry in filter links
const ALLOWED_NON_FACET_PARAMS = new Set(['sort', 'n_item', 'q'])

export function updateFacetRoutes(
  facets: { [key: string]: IReflektionFacet } = {},
  query: LocationQuery = {}
): void {
  const facetKeys = new Set(Object.keys(facets))
  const queryCopy = Object.fromEntries(
    Object.entries(query).filter(([key]) => facetKeys.has(key) || ALLOWED_NON_FACET_PARAMS.has(key))
  ) as LocationQuery

  Object.keys(facets)
    .filter(filterKey => filterKey !== 'nextCategoryLevel')
    .forEach(filterKey => {
      let applied = queryCopy[filterKey] || []

      if (!Array.isArray(applied)) {
        applied = [applied]
      }

      // Run this for every option
      facets[filterKey]?.value?.forEach(val => {
        // Get the key. If the current route does not include this key, we are going to add it to the route
        // otherwise we will remove it.

        const key = val.urlKey === 'black_friday_dropship' ? '5for5' : val.urlKey
        const index = applied.indexOf(key)
        const routeQuery = { ...queryCopy }
        val.active = index !== -1
        if (index === -1) {
          if (SINGLE_FACET.indexOf(filterKey) !== -1) {
            routeQuery[filterKey] = [key]
          } else {
            routeQuery[filterKey] = [...applied, key].sort()
          }
        } else if (applied.length === 1) {
          delete routeQuery[filterKey]
        } else {
          const copy = applied.slice(0)
          copy.splice(index, 1)
          routeQuery[filterKey] = copy
        }

        // Update the `route` property on this facet so it can be used in the sidebar etc
        val.route = { query: routeQuery }
      })
    })
}
